<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <!--单据编号-->
                <el-col :span="6">
                  <el-form-item :label="$t('apply.no')" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <!--类型-->
                <el-col :span="6">
                  <el-form-item :label="$t('apply.applyType')" prop="applyType">
                    <el-select class="handle-input" v-model="queryCondition.applyType" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--主题-->
                <el-col :span="6">
                  <el-form-item :label="$t('apply.subject')" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <!--入围供应商-->
                <el-col :span="6">
                  <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierCode">
                    <el-input class="handle-input" :disabled="true" v-model="supplierCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <!--报价类型-->
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                      <el-select class="handle-input" v-model="queryCondition.quotationType" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!--申请单状态-->
                  <el-col :span="6">
                    <el-form-item :label="$t('apply.status')" prop="status">
                      <el-select class="handle-input" v-model="queryCondition.status" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value="all"></el-option>
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <!--创建人-->
                  <el-col :span="6">
                    <el-form-item :label="$t('common.createBy')" prop="buyerName">
                      <el-input class="handle-input" v-model="queryCondition.buyerName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryFormThis()" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="ApplyAddSp" @click="addNewApply(-99999)">{{$t('common.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="quotationApplyDeleteApplySp" @click="deleteQuotationApply">{{$t('common.del')}}</el-button>
      </el-row>
      <el-table sortable max-height="435" :data="applyList" ref="applyDataTable" border highlight-current-row class="table">
        <el-table-column align="center" fixed width="56" :label="$t('common.select')">
          <!--选择-->
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttQuotationApplyId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <!--单据编号-->
        <el-table-column show-overflow-tooltip fixed sortable prop="applyNo" :label="$t('apply.no')" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.applyNo}} </el-link>
          </template>
        </el-table-column>
        <!--类型-->
        <el-table-column show-overflow-tooltip sortable prop="applyTypeI18n" :label="$t('apply.applyType')" min-width="80px"></el-table-column>
        <!--主题-->
        <el-table-column show-overflow-tooltip sortable prop="subject" :label="$t('apply.subject')" min-width="180px"></el-table-column>
        <!--入围供应商-->
        <el-table-column show-overflow-tooltip sortable prop="supplierNames" :label="$t('apply.shortlistedSuppliers')" min-width="180px"></el-table-column>
        <!--报价类型-->
        <el-table-column show-overflow-tooltip sortable prop="quotationTypeI18n" :label="$t('apply.quotationType')" min-width="90px"></el-table-column>
        <!--创建人-->
        <el-table-column show-overflow-tooltip sortable prop="name" :label="$t('common.createBy')" min-width="90px"></el-table-column>
        <!--创建日期-->
        <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="100px"></el-table-column>
        <!--申请单状态-->
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" :label="$t('apply.status')" min-width="80px"></el-table-column>

      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
  </div>
</template>
<script>
import { applyService } from "../../../api/quotation-apply-sup/quotation-apply";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
import { Message } from "element-ui";
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
export default {
  name: 'apply',
  mixins: [paginationMixin],
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      totalCount: 0,
      applyList: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        supplierCode: null,
        quotationType: null,
        status: null,
        createDate: null,
        createEndDate: null,
        buyerName: null,
      },
      statusList: [],
      quotationStatusList: [],
      sourcingStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      radioVal: null,
      selectRow: null,
      supplierCode: '',
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    applyService.getQuotationApplyData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.applyList = res.resultData;
        vm.totalCount = res.totalCount;
        vm.supplierCode = res.otherInfo;
      })
    })
  },
  created() {
    //this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      applyService.getQuotationApplyData(this.queryCondition).then((res) => {
        this.applyList = res.resultData;
        this.totalCount = res.totalCount;
        this.supplierCode = res.otherInfo;
      });
    },
    addNewApply: function (applyId) {
      this.$router.replace({ name: 'applySpDetail', params: { applyId: applyId, source: 'apply' } });
    },
    openQuotationApplyDetail: function (row) {
      if (this.actionCheck.actionCheck('ApplyInfo') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false

      }
      this.$router.replace({ name: 'applySpDetail', params: { applyId: row.ttQuotationApplyId, source: 'apply', applyType: row.applyType } });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    deleteQuotationApply: function () {
      if (this.selectRow == null) {
        //请选择需要删除的申请单
        Message({ message: this.$t('apply.selectDelApply'), type: "warning" });
      } else {
        let delId = this.selectRow.ttQuotationApplyId;
        if (this.selectRow.source != 'SUP') {
          Message({ message: "只能操作供应商自己创建的单据", type: "warning" });
          return;
        }
        //判断单据是否为草稿状态
        if (this.selectRow.status != '1') {
          //只有草稿状态的申请单才可以删除
          Message({ message: this.$t('apply.delApplyParam'), type: "warning" });
          return;
        }
        // //请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          applyService.delSelQuotationApply(delId).then((res) => {
            if (res.meta.success) {
              this.selectRow = null;
              this.radioVal = null;
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
          });
        }).catch(() => {

        });
      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:STATUS"] = "TT_QUOTATION_APPLY:STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["TT_QUOTATION_APPLY:STATUS"];
        this.quotationStatusList = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusList = res["TT_SOURCING:STATUS"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        applyType: null,
        subject: null,
        supplierCode: null,
        quotationType: null,
        status: null,
        createDate: null,
        createEndDate: null,
        buyerName: null,
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
.el-input {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
